/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWebAnalyticsLogo = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 8.5V7H4v1.5h1zM6.75 8.5h-1v-3h1v3zM8.5 8.5V4h-1v4.5h1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.722 2.343A5 5 0 016.5 1.5a5.005 5.005 0 015 5 5 5 0 01-1.129 3.164l4.108 4.107-.707.708-4.108-4.108a4.999 4.999 0 11-5.942-8.028zM6.5 2.5a4 4 0 100 8 4 4 0 000-8z"
}));

export default SvgWebAnalyticsLogo;